<template>
  <span>

    <v-menu :open-on-hover="openOnHover" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" :loading="loading || printLoading" :width="width" :disabled="disabled" 
          :height="37" v-on="on" :class="$store.state.Settings.darkTheme == true ? 'white--text ' + classes : classes">
          <v-icon dark left>mdi-cloud-print-outline</v-icon>
          <span>{{ $t(btnText) }}</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item class="cursor_pointer" v-print="printObj">
          <v-list-item-title class="d-flex align-center" v-if="pdf">
            <img src="@/assets/img/svg/download-pdf.svg" height="17" class="mx-2" alt="Qarat">
            <p class="my-0">PDF</p>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="excel">
          <v-list-item-title class="cursor_pointer d-flex align-center" @click="exportExcel">
            <img src="@/assets/img/svg/microsoft-excel.svg" height="17" class="mx-2" alt="Qarat">
            <p class="my-0">Excel</p>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <div id="printContent">
      <PrintTable :tableHeight="'auto'" :header="header" :maxPDFRows="maxPDFRows" :printTitle="printTitle"
        :printSubTitle="printSubTitle" :printSubTitleLeft="printSubTitleLeft" :printSubTitleRight="printSubTitleRight"
        :customize_header_footer="customize_header_footer" :data="exportData || []" :printStaticData="printStaticData"
        :header_slot="header_slot" :footer_slot="footer_slot" :showGroupHeader="groupHeader.length"
        :groupHeader="groupHeader" :footerData="footerData || []" :pdfOrientation="pdfOrientation">
        <template v-slot:before_table>
          <slot name="before_table" />
        </template>
        <template v-slot:pdf_header>
          <slot name="pdf_header"  />
        </template>
        <template v-slot:after_table>
          <slot name="after_table"  />
        </template>
        <template v-slot:pdf_footer>
          <slot name="pdf_footer"  />
        </template>
        <template v-slot:td="{ row, header, index }">
          <slot name="td" :row="row"  :header="header" :index="index"></slot>
        </template>
      </PrintTable>
    </div>


  </span>
</template>


<script>
import PrintTable from "./PrintTable.vue";
export default {
  name: "ExportBtnNB",
  props: {
    btnText: { default: 'print' },
    width: { default: 130 },
    pdf: { default: true },
    excel: { default: true },
    image: { default: true },
    disabled: { default: false },
    loading: { default: false },
    openOnHover: { default: false },
    classes: { default: " backgroundW black--text shadow" },
    exportData: { default: () => [] },
    footerData: { default: () => [] },
    header: { default: () => [] },
    attachmentFileName: { default: 'مرفق' },
    printTitle: { default: null },
    printSubTitle: { default: null },
    printSubTitleLeft: { default: null },
    printSubTitleRight: { default: null },
    maxPDFRows: { default: 48 },
    groupHeader: { default: () => [] },
    showGroupHeader: { default: false },
    customize_header_footer: { default: false },
    printStaticData: { type: Object, default: () => ({}) },
    header_slot: { default: false },
    footer_slot: { default: false },
    pdfOrientation: { default: 'portrait' },
  },
  data: () => ({
    printLoading: false,
  }),
  computed: {
    printObj() {
      return {
        id: "printContent",
        popTitle: null,
        previewTitle: null,
        previewPrintBtnLabel: null,
        preview: false,
        clickMounted: (vue) => {
          vue.printLoading = true;
        },
        openCallback: (vue) => {
          vue.printLoading = false;
        },
        closeCallback: (vue) => {
          vue.printLoading = false;
        },
      }
    }
  },
  watch: {},
  components: {
    PrintTable,
  },
  mounted() {
    const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
        @media print {
          @page {size: A4 ${this.pdfOrientation}; margin: 0; }
        }
      `;
      document.head.appendChild(style);
  },
  beforeDestroy: function () {

  },
  methods: {
    exportPDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    exportExcel() {
      this.$global.ExportExcel(
        this.exportData,
        this.header,
        this.footerData || [],
        this.$i18n.t(this.attachmentFileName)
      )
    },
  },
};
</script>



<style  lang="scss">
#printContent {
  &:not(.view) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    clip-path: inset(50%) !important;
    white-space: nowrap !important;
    border: 0 !important;
    z-index: -1 !important;

    @media print {
      position: static !important;
      width: auto !important;
      height: auto !important;
      margin: 4mm !important;
      padding: unset !important;
      overflow: visible !important;
      clip: auto !important;
      clip-path: none !important;
      white-space: normal !important;
      z-index: 2 !important;
    }
  }




  #fileHeader {

    tr,
    th {
      padding: 0 !important;
      border: 0 !important;
      background-color: transparent !important;
    }
  }

  #fileFooter {


    tr,
    th {
      padding: 0 !important;
      border: 0 !important;
      background-color: transparent !important;
    }
  }
}
</style>